import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { FormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { startOfDay, endOfDay, isSameDay } from 'date-fns';
import { firstValueFrom, Subject } from 'rxjs';
import { CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarView, } from 'angular-calendar';
import { DAYS_OF_WEEK, EventColor } from 'calendar-utils';

import { ComponentBase, DialogData } from '@definitiv-packages/angular-dba-library';

import { ObjektModelView, ObjektViewService, ProjectLanguage, SafetyPointFormModelView, SafetyPointFormModelViewService, SafetyPointModelView, SafetyPointViewService, ServiceModelView, ServiceViewService, TodoModelView, TodoViewService }
 from '../../../../../roofsafetymanagement-library/src/public-api';

import { CreateServiceComponent } from '../../dialogs/create-service/create-service.component';
import { CloseServiceComponent } from '../../dialogs/close-service/close-service.component';
import { Router } from '@angular/router';

const colors: Record<string, EventColor> = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
  green: {
    primary: '#0e9720ff',
    secondary: '#85e7a3ff',
  },
  gray: {
    primary: '#aaaaaaff',
    secondary: '#ddddddff',
  },
};

type CssClass = 'objekt' | 'maintenance' | 'commission' | 'order' | 'external';

abstract class Event<T> implements CalendarEvent<T> {
  public start: Date = new Date();
  public end?: Date;
  public color?: EventColor;
  public actions?: CalendarEventAction[];
  public allDay?: boolean;
  public content?: string;
  public cssClass?: CssClass;
  public resizable?: { beforeStart?: boolean; afterEnd?: boolean; };
  public draggable?: boolean;

  constructor(
    public id: string | number,
    public meta: T,
    public title: string
  ) { }
}

class RSMEvent extends Event<TodoModelView> { }

@Component({
  selector: 'calendar-view',
  templateUrl: './calendar-view.component.html',
  styleUrls: ['./calendar-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CalendarViewComponent extends ComponentBase<ProjectLanguage> implements OnInit {
  public locale: string = this.languageService.locale;
  public weekStartsOn: number = DAYS_OF_WEEK.MONDAY;
  public excludeDays: number[] = [];
  public withWeekend: boolean = true;
  public events: CalendarEvent[] = [];
  public searchevents: CalendarEvent[] = [];
  public selectedsearchevent: CalendarEvent = {} as CalendarEvent;
  public starthour = 6;
  public endhour = 18;
  public serviceList: ServiceModelView[] = [];
  public safetyPointFormList   : SafetyPointFormModelView[]=[];
  public safetyPointList   : SafetyPointModelView[]=[];
  public todoList   : TodoModelView[]=[];
  public objektList   : ObjektModelView[]=[];
  public refresh: Subject<any> = new Subject();
  public view: CalendarView = CalendarView.Month;
  public CalendarView = CalendarView;
  public viewDate: Date = new Date();
  public filterValue: string | null = "";
  public isSet: boolean = false;
  public activeDayIsOpen: boolean = false;

  private SearchControl: FormControl<string | null> = new FormControl<string | null>(null);

  public FormGroup = new UntypedFormGroup({
    searchControl: this.SearchControl
  });

  private closeServiceAction: CalendarEventAction = {
    label: '<i class="material-icons mat-icon mat-icon-kalender">done</i>',
    onClick: event => this.closeService(event.event as unknown as RSMEvent)
  }

  private stornoServiceAction: CalendarEventAction = {
    label: '<i class="material-icons mat-icon mat-icon-kalender">close</i>',
    onClick: event => this.closeService(event.event as unknown as RSMEvent)
  }

  private editServiceAction: CalendarEventAction = {
    label: '<i class="material-icons mat-icon mat-icon-kalender">edit</i>',
    onClick: event => this.editObjekt(event.event as unknown as RSMEvent)
  }

  private mapServiceAction: CalendarEventAction = {
    label: '<i class="material-icons mat-icon mat-icon-kalender">public</i>',
    onClick: event => this.mapService(event.event as unknown as RSMEvent)
  }

  private openServiceAction: CalendarEventAction = {
    label: '<i class="material-icons mat-icon mat-icon-kalender">open_in_new</i>',
    onClick: event => this.openService(event.event as unknown as RSMEvent)
  }

  constructor(
    private dialog: MatDialog,
    private serviceviewService: ServiceViewService,
    private todoservice : TodoViewService,
    private objektViewService : ObjektViewService,
    private router: Router,
    private safetyPointFormModelViewService : SafetyPointFormModelViewService,
    private safetyPointViewService : SafetyPointViewService
  ) { super(); }

  public async ngOnInit() {

    this.loading = true;
    var resultList = await Promise.all([
        this.serviceviewService.getList(),
        this.safetyPointFormModelViewService.getList(),
        this.todoservice.getList(),
        this.objektViewService.getList(),
        this.safetyPointViewService.getList()
    ])
    
    this.serviceList          = resultList[0];
    this.todoList             = resultList[2];
    this.safetyPointFormList  = resultList[1];
    this.objektList           = resultList[3];
    this.safetyPointList      = resultList[4];    
    this.LoadEvents();
  }

  private LoadEvents() {
    this.events = [];
    this.loadServiceEventList();
  }

  private async loadServiceEventList(): Promise<void> {
    try {

      this.todoList.sort((a,b)=>{
        return (new Date(a.CreatedOn!)<new Date(b.CreatedOn!))?-1:1
      }).forEach(todo=>{
            var objekt = this.objektList.find(x=>x.ObjektID == todo.ObjektId);

            if(objekt && this.safetyPointList.filter(x=>x.ObjektID == objekt?.ObjektID).length>0){
                var event = this.setobjektevent(todo,objekt)
                this.events.push(event);
            }
      })
      this.loading = false;
      /*
      this.serviceList.
        sort((a, b) => new Date(a.LaufzeitVon!).getTime() - new Date(b.LaufzeitVon!).getTime()).
        forEach(service => {
          var event = this.setobjektevent(todo);
          this.events.push(event);
        })
        */
    }
      
    finally {
      this.refresh.next(null);
      this.loading = false;
    }
  }


  private setobjektevent(todo:TodoModelView, objekt: ObjektModelView): RSMEvent {
    var isMap: boolean = false;

    var title = objekt.Bezeichnung;
    if (objekt.Strasse || objekt.PLZ || objekt.Ort || objekt.LandName) {
      title += " - " + todo.TodoId+"<br/>";
      if (objekt.Strasse) title += ' ' + objekt.Strasse+ "<br/>";
      if (objekt.PLZ) title += ' ' + objekt.PLZ +" ";
      if (objekt.Ort) title += ' ' + objekt.Ort +" <br/>";
      if (objekt.LandName) title += ' ' + objekt.LandName;

      if (objekt.Strasse && objekt.PLZ && objekt.Ort)
        isMap = true;
    }

    var content =  this.safetyPointFormList.filter(x=>x.ObjektID== objekt.ObjektID && x.TodoId==todo.TodoId).length +"/ " + objekt.SafetyPointCount?.toString();
    
    //var content =  objekt.RoofAreaCount?.toString() + " | " + objekt.SafetyPointCount?.toString();
    var event = new RSMEvent("Todo" + todo.ObjektId.toString(), todo, title!);

    event.allDay = true;
    event.start = new Date(todo.Termin)
    event.end = new Date(todo.Termin)
    event.actions = [];

    if((this.safetyPointFormList.filter(x=>x.TodoId == todo.TodoId)).length == this.safetyPointList.filter(y=>y.ObjektID == objekt.ObjektID).length && this.safetyPointList.filter(y=>y.ObjektID == objekt.ObjektID).length>0){
      event.color = { ...colors['green'] }
    }

    if(this.safetyPointFormList.filter(x=>x.TodoId == todo.TodoId).length==0){
      event.color = { ...colors['red'] }
    }

    this.seteventactions(event as CalendarEvent)


    event.content = content;
    if (isMap)
      event.actions.push(this.mapServiceAction)
    return event;
  }  
  /*
  private setserviceevent(service: ServiceModelView): RSMEvent {
    var isMap: boolean = false;

    var title = service.Bezeichnung;
    if (service.Strasse || service.PLZ || service.Ort || service.LandName) {
      title += " /";
      if (service.Strasse) title += ' ' + service.Strasse;
      if (service.PLZ) title += ' ' + service.PLZ;
      if (service.Ort) title += ' ' + service.Ort;
      if (service.LandName) title += ' ' + service.LandName;

      if (service.Strasse && service.PLZ && service.Ort)
        isMap = true;
    }
    var content = "O | " + service.RoofAreaCount?.toString() + " | " + service.SafetyPointCount?.toString();
    var event = new RSMEvent("Service" + service.ServiceID.toString(), service, title,);

    event.allDay = true;
    event.start = new Date(service.LaufzeitVon!)
    event.end = new Date(service.LaufzeitVon!)
    event.actions = [];


    this.seteventactions(event as CalendarEvent)


    event.content = content;
    if (isMap)
      event.actions.push(this.mapServiceAction)
    return event;
  }
*/

  private seteventactions(event: CalendarEvent) {
    var service = this.serviceList.find(x => x.ServiceID == event.meta.ServiceID)
    if (service) {
      event.color = { ...colors['green'] }
      event.actions = [this.closeServiceAction, this.stornoServiceAction, this.editServiceAction];
    }
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {

    if ((isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) || events.length === 0)
      this.activeDayIsOpen = false;
    else this.activeDayIsOpen = true;
    this.viewDate = date;

    // if (isSameMonth(date, this.viewDate)) {
    //   if (
    //     (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
    //     events.length === 0
    //   ) {
    //     this.activeDayIsOpen = false;
    //   } else {
    //     this.activeDayIsOpen = true;
    //   }
    //   this.viewDate = date;
    // }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });
    this.handleEvent('Dropped or resized', event);
  }

  handleEvent(action: string, event: CalendarEvent): void {
       this.router.navigate(['/todos',event.meta.TodoId]);
  }   

  addEvent(): void {
    this.events = [
      ...this.events,
      {
        title: 'New event',
        start: startOfDay(new Date()),
        end: endOfDay(new Date()),
        color: colors['red'],
        draggable: true,
        resizable: {
          beforeStart: true,
          afterEnd: true,
        },
      },
    ];
  }

  deleteEvent(eventToDelete: CalendarEvent) {
    this.events = this.events.filter((event) => event !== eventToDelete);
  }

  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

  public toggleWithWeekend(e: any): void {
    if (!e) this.excludeDays = [DAYS_OF_WEEK.SATURDAY, DAYS_OF_WEEK.SUNDAY];
    else this.excludeDays = [];
  }

  public onEventChange(): void {
    this.LoadEvents();
  }

  private async closeService(event: RSMEvent): Promise<void> {
    var result = await firstValueFrom(this.dialog.open(CloseServiceComponent, { data: event.meta }).afterClosed());
    if (result) this.LoadEvents();
  }

  private openService(event: RSMEvent): void {
    this.dialog.open(CloseServiceComponent, { data: event.meta }).afterClosed().subscribe((result) => {
      if (result) this.LoadEvents();
    });
  }

  private async editObjekt(event: RSMEvent) {
    var objekt = await this.objektViewService.get(event.meta.TodoId);
    const objektData = new DialogData<ObjektModelView>(objekt, 'edit');

    this.dialog.open(CreateServiceComponent, { autoFocus: false, data: objektData }).afterClosed().subscribe(async (result) => {
      if (result) {
        const updatedService =
          await this.serviceviewService.get(event.meta.TodoId);

      //  this.replaceserviceevent(updatedService);
      }
    });
  }

  private async mapService(event: RSMEvent) {
    var objekt = this.objektList.find(x=>x.ObjektID == event.meta.ObjektId);
    if(!objekt) return
    var adress = objekt.Strasse + ", " + objekt.PLZ + " " + objekt.Ort;
    const url = "https://www.google.com/maps?q=" + adress + '&z=16';
    window.open(url, '_blank');
  }


 

  public clear(): void {

    if (this.searchevents.length > 0) {

      this.searchevents.forEach(event => {
        this.seteventactions(event as CalendarEvent)
      });

      this.filterValue = null;
      this.SearchControl.setValue(null)
      this.isSet = false;

      this.searchevents = [];
      this.viewDate = new Date()
      this.activeDayIsOpen = false;
    }
  }
  public onInput(value: string) {
    this.filterValue = value;
  }

  public searchEvents(value: string | null) {
    this.isSet = false;
    if (value) {
      if (this.searchevents.length > 0)
        this.searchevents.forEach(event => {
          this.seteventactions(event as CalendarEvent)
        });

      this.searchevents = [];
      var list = this.events.filter(x => x.title.toUpperCase().includes(value.toUpperCase()))

      list.forEach(event => {
        event.color = { ...colors['yellow'] }
        this.searchevents.push(event)
      })

      if (this.searchevents.length > 0) {
        this.selectedsearchevent = this.searchevents[0]
        this.selectedsearchevent.color = { ...colors['blue'] }
        this.viewDate = this.selectedsearchevent.start;
        this.activeDayIsOpen = true;
        this.isSet = true;
      }
    }
  }

  public searchSkipEvent(value: number) {
    var index = this.searchevents.findIndex(x => x.meta.ServiceID === this.selectedsearchevent.meta.ServiceID)
    index = index + value

    if (index >= this.searchevents.length)
      index = 0;
    if (index < 0)
      index = this.searchevents.length - 1;

    this.searchevents.forEach(event => {
      event.color = { ...colors['yellow'] }
    });
    this.selectedsearchevent = this.searchevents[index]
    this.selectedsearchevent.color = { ...colors['blue'] }
    this.viewDate = this.selectedsearchevent.start;
    this.activeDayIsOpen = true;
  }
}
